module.exports = __webpack_public_path__ + "img/profile.f3d8af8a.svg";